export const TIMESHEET = {
  ROOT: '/timesheet',
  APARTMENTS: '/timesheet/apartments',
  ENG_NETWORKS: '/timesheet/engNetworks',
};
